import { getDefaultImageUrl } from "@faire/deprecated-retailer-visitor-shared/components/Image/ProgressiveProductImage";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Row } from "@faire/web/slate/Layout";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { FaireLogo } from "@faire/web/ui/logos/FaireLogo";
import React from "react";
import styled from "styled-components";

interface IProps {
  logo: boolean;
  image?: IImage;
  isFeaturedImageLoading?: boolean;
}

export const ImageOrLogo: React.FC<IProps> = ({
  logo: renderLogo,
  image,
  isFeaturedImageLoading = false,
}) => {
  const logo = <FaireLogo size={104} />;
  const isSSR = useIsSSR();

  if (renderLogo) {
    return logo;
  }

  /**
   * Logo is rendered when no image is loading or given, but during server side rendering,
   * if renderLogo is false, then we don't know what will happen in client
   * side, so we return loading spinner as the default to make sure whatever happens
   * in the client side, users will not experience a janky page.
   */

  if (isFeaturedImageLoading || isSSR) {
    return (
      <Container data-test-id="sign-up-image-spinner">
        <LoadingSpinner />
      </Container>
    );
  }

  if (image) {
    return (
      <Container>
        <img
          src={getDefaultImageUrl(image, isSSR, {})}
          alt="Sign up featured image"
        />
      </Container>
    );
  }

  return logo;
};

const Container = styled(Row).attrs({ align: "center", justify: "center" })`
  width: 144px;
  height: 144px;

  img {
    display: block;
    width: 100%;
  }

  ${responsiveMediaQueries.mobile} {
    width: 112px;
    height: 112px;
  }
`;
